import {createURL} from "./client";
import axios from "axios";
import {generateIdempotencyKey} from "../utils/idempotency";

// getTournaments получает список активных турниров
export async function getTournaments() {
    return await axios.get(createURL("/api/tournaments"));
}

// getJoinableTournamentsCount получает количество турниров, доступных для вступления
export async function getJoinableTournamentsCount() {
    return await axios.get(createURL("/api/tournaments/joinable-count"));
}

// joinTournament присоединяет игрока к турниру
export async function joinTournament(tournamentID, options = {}) {
    const idempotencyKey = options.idempotencyKey || generateIdempotencyKey();
    return await axios.post(
        createURL("/api/tournaments/join"),
        {tournament_id: tournamentID},
        {headers: {"Idempotency-Key": idempotencyKey}},
    );
}

// checkTournamentParticipation проверяет участие игрока в турнире
export async function checkTournamentParticipation(tournamentID) {
    return await axios.post(createURL("/api/tournaments/check-participation"), {
        tournament_id: tournamentID,
    });
}

// getTournamentLeaders получает лидеров турнира и позицию пользователя
export async function getTournamentLeaders(tournamentID) {
    return await axios.get(createURL(`/api/tournaments/leaders?tournament_id=${tournamentID}`));
}

// getTournamentHistory получает историю завершенных турниров с пагинацией
export async function getTournamentHistory(page = 1, limit = 9) {
    return await axios.get(createURL(`/api/tournaments/history?page=${page}&limit=${limit}`));
}
